import { useEffect, useState, useRef } from 'react'

import { roomKeys } from 'helpers/events'

import useVideoContext from '../useVideoContext/useVideoContext'

export default function useRoomState() {
    const { room } = useVideoContext()
    const isMountedRef = useRef(false)
    const [state, setState] = useState('disconnected')

    useEffect(() => {
        isMountedRef.current = true
        return () => {
            isMountedRef.current = false
        }
    }, [])

    useEffect(() => {
        const setRoomState = () => {
            if (isMountedRef.current) {
                setState(room.state || 'disconnected')
            }
        }
        setRoomState()

        room.addListener(roomKeys.DISCONNECTED, setRoomState)
        room.addListener(roomKeys.RECONNECTED, setRoomState)
        room.addListener(roomKeys.RECONNECTING, setRoomState)

        return () => {
            room.removeListener(roomKeys.DISCONNECTED, setRoomState)
            room.removeListener(roomKeys.RECONNECTED, setRoomState)
            room.removeListener(roomKeys.RECONNECTING, setRoomState)
        }
    }, [room])

    // return roomState.current;
    return state
}
